export default {
  state: () => ({
    _log: []
  }),

  getters: {
    errorlog: (state) => state._log
  },

  mutations: {
    addErrorLog(state, payload) {
      state._log.push({ time: (new Date()).toLocaleString(), error: payload })
    },
  },

  actions: {
  }
}